var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/markdown_button.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ComposeFormButton from './compose_form_button';
const messages = defineMessages({
  marked: {
    "id": "compose_form.markdown.marked",
    "defaultMessage": "Post markdown enabled"
  },
  unmarked: {
    "id": "compose_form.markdown.unmarked",
    "defaultMessage": "Post markdown disabled"
  }
});
const MarkdownButton = ({
  active,
  onClick
}) => {
  const intl = useIntl();
  return /*#__PURE__*/React.createElement(ComposeFormButton, {
    icon: require('@tabler/icons/markdown.svg'),
    title: intl.formatMessage(active ? messages.marked : messages.unmarked),
    active: active,
    onClick: onClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  });
};
export default MarkdownButton;